module.exports = __webpack_public_path__ + "04_glasses_black.8bc7a82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer4/04_glasses_black.png
// module id = nttS
// module chunks = 0